import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { PermissionsResponseData } from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const PERMISSIONS_QUERY_KEY = 'permissions';

export const usePermissionsQuery = (url: string) =>
  useQuery({
    queryKey: [PERMISSIONS_QUERY_KEY, url],
    queryFn: () =>
      HttpClient.request<PermissionsResponseData>({
        method: 'GET',
        url,
      }),
    enabled: !!url,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
